<template>
  <div class="step step_0"  :class="{'form__step_hidden': step != number}" :aria-labelledby="`step${number}-title`">
    <RadioGroup :value="stepsdata[number][names[0]]" @input="setval" :grid="true" :gridstay="true" :name="names[0]" title="Хотите добавить созаемщика?" :required="true" :values="['Да','Нет']"/>
    <div class="form__btns">
      <Btn class="btn_gray" @click.native.prevent="$store.commit('prevStep')">Назад</Btn>
      <Btn @click.native.prevent="$store.commit('nextStep')" :disabled="!filled() || step != number">Далее</Btn>
    </div>
  </div>
</template>

<script>
import Btn from './ui/Btn.vue'
import RadioGroup from './RadioGroup.vue'
import { mapState } from 'vuex'

export default {
  props: {
    number: {type: Number, default: 14},
    cob: {type: Number, default: 1}
  },
  mounted(){
    if (!this.stepsdata[this.number][this.names[0]])
      this.stepsdata[this.number][this.names[0]] = undefined
    this.$store.commit('addCob', this.number)
  },
  beforeUnmount(){
    this.$store.commit('removeCob', this.number)
  },  
  data: (ctx)=>({
    names: [`debtcoborrowerquestion${ctx.cob}`]
  }),
  components: { Btn, RadioGroup },
  methods: {
    setval(e){ 
      let data = { [this.names[0]]: e }
      this.$set(this.stepsdata, this.number, data)
    },
    filled(){
      return  true
    }
  },
  computed: {
    ...mapState(['stepsdata','step']),
  },

}
</script>

<style lang="sass">
</style>